module.exports = __webpack_public_path__ + "img/Welcome.c159602c.png";